/* eslint-disable no-case-declarations */
import '@lottiefiles/lottie-player';
import { convertElement } from './helpers';

export const loadLottie = (el) => new Promise((resolve) => {
	const lottie = convertElement(el, 'lottie-player');

	const readyListener = () => {
		lottie.removeEventListener('ready', readyListener); // Remove the event listener
		resolve(lottie); // Resolve the promise with the lottie element
	};

	lottie.addEventListener('ready', readyListener);
});

class LottieController {
	hasPlayed = false;

	constructor(el) {
		this.el = el;
		this.delay = this.el.getAttribute('data-delay') || 0;
		this.playTrigger = this.el.getAttribute('data-play-trigger') || 'inview';

		this.observe();

		switch (this.playTrigger) {
			case 'hover':
				const { hoverTarget } = this.el.dataset;
				const hoverTargetEl = this.el.closest(hoverTarget) || this.el.parentElement;
				hoverTargetEl.addEventListener('mouseenter', () => {
					this.play();
				});
				break;

			default:
				break;
		}
	}

	observe = () => {
		this.observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const { isIntersecting } = entry;
				if (isIntersecting) {
					this.load();
					this.observer.unobserve(this.el);
				}
			});
		}, {
			threshold: 0,
			rootMargin: '-50px 0px',
		});

		this.observer.observe(this.el);
	}

	// function that convertions this.el from a lazy-lottie-player to a lottie-player
	load = async () => {
		this.lottie = await loadLottie(this.el);
		if (this.playTrigger === 'inview') {
			this.lottie.play();
		}
	}

	play = () => {
		this.lottie.seek(0);
		setTimeout(() => {
			this.lottie.play();
		}, this.delay);
	}
}

const players = [...document.querySelectorAll('lazy-lottie-player')];
if (players.length) {
	players.map((el) => new LottieController(el));
}
